import type {
  DeleteSnapQuoteAttachmentOutput,
  DeleteSnapQuoteAttachmentRequest,
} from '@snap-types/actions/delete-snap-quote-attachment';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [deleteSnapQuoteAttachment, useDeleteSnapQuoteAttachmentMutation] =
  injectMutation<
    DeleteSnapQuoteAttachmentRequest,
    DeleteSnapQuoteAttachmentOutput
  >(`${QUOTE_BUILDER_SLICE_NAME}/deleteSnapQuoteAttachment`, ({ params }) => ({
    url: buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteUuid,
      `${params.snapQuoteVersionUuid}/attachments/${params.attachmentUuid}`,
    ),
    method: 'DELETE',
  }));
